import { render, staticRenderFns } from "./associated-people.html?vue&type=template&id=bf96283e&scoped=true&"
import script from "./associated-people.js?vue&type=script&lang=js&"
export * from "./associated-people.js?vue&type=script&lang=js&"
import style0 from "./associated-people.scss?vue&type=style&index=0&id=bf96283e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf96283e",
  null
  
)

export default component.exports